import isNil from 'lodash'

export default {
  props: {
    title: {
      type: String,
      required: true
    },
    message: {
      type: String,
      required: true
    },
    solutionList: {
      type: Array,
      required: false,
      default: null
    }
  },
  computed: {
    haveList () {
      return !isNil(this.solutionList) && this.solutionList.length !== 0
    }
  }
}



// WEBPACK FOOTER //
// ./src/components/component/error/error.js